import { getFormattedValueAndUnitFromNumber } from 'ComponentLibrary/src/common/numbers'

class YearPeriod {
    readonly value: number
    constructor(value: number) {
        this.value = value
    }

    format({ withUnit }: { withUnit?: boolean } = { withUnit: true }) {
        const unit = Math.abs(this.value) === 1 ? 'Jahr' : 'Jahre'
        return withUnit ? `${this.value} ${unit}` : `${this.value}`
    }
}

export function getFormattedValueAndUnitFromYearPeriod(period?: number, locale = 'de-DE') {
    if (!period) {
        return { value: '-' }
    }
    const yearPeriodClassObject = new YearPeriod(period)
    const unit = locale === 'en-US' ? (Math.abs(period) === 1 ? 'year' : 'years') : Math.abs(period) === 1 ? 'Jahr' : 'Jahre'
    return getFormattedValueAndUnitFromNumber(yearPeriodClassObject.value, unit, undefined, locale)
}

const isYearPeriod = (yearPeriod: YearPeriod | unknown): yearPeriod is YearPeriod => {
    if (!(yearPeriod instanceof YearPeriod)) {
        return false
    }
    return !isNaN(yearPeriod.value)
}

export { YearPeriod, isYearPeriod }
